export default "__VITE_ASSET__sMc47iWf__"